/**
 * Utility functions to reduce repetition in translation processing
 * Simple helpers that can be used to optimize existing translation functions
 */

// Helper to initialize translatedItems (common first step in all functions)
export const initTranslatedItems = (translatedItems: any) => {
  if (!translatedItems || Object.keys(translatedItems).length === 0) {
    translatedItems = {};
  }
  return translatedItems;
};

// Helper to safely parse complex JSON objects with fallback (common pattern)
export const parseComplexObject = (translatedItems: any, objectConstant: any) => {
  const parsedValue = translatedItems[JSON.stringify(objectConstant)];
  if (parsedValue) {
    try {
      return typeof parsedValue === 'string' ? JSON.parse(parsedValue) : parsedValue;
    } catch {
      return objectConstant;
    }
  }
  return objectConstant;
};
